<template>
  <!-- محتویات تب لیست اسناد -->
  <div class="row p-3">
    <div class="col-12 p-0">
      <div class="row p-0 d-flex justify-content-between align-items-center">
        <!-- جستجوی پیشرفته در لیست اسناد -->
        <div class="col-4 p-0 pb-2">
          <div class="input-group p-0">
            <input
              id="textDocInfoSearch"
              placeholder="جستجو پیشرفته در لیست اسناد (Enter)"
              type="text"
              class="form-control form-control-sm rounded-0"
              v-on:focus="$event.target.select()"
              v-on:keyup.enter="
                FilterDataInSearch($event.target.value);
                $event.target.select();
              "
            />
            <div class="input-group-prepend rounded-0">
              <span
                class="input-group-text input-group-box-size bg-secondary rounded-left white-text"
              >
                <a v-on:click="FilterDataInSearch('Search')">
                  <i class="fas fa-search"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div class="col text-right">
          <span>{{ ListSearchOld }}</span>
        </div>
        <!-- منوهای سمت چپ -->
        <div
          class="col-4 p-0 pb-2 d-flex justify-content-end align-items-center"
        >
          <!-- تغییر وضعیت اسناد -->
          <div style="position: relative">
            <a
              class="btn btn-sm btn-floating p-0 m-0 ml-1 d-flex justify-content-around align-items-center"
              :class="
                isShowChangeStatusDoc == true ? 'btn-warning' : 'btn-secondary'
              "
              style="width: 35px; height: 30px"
              title="تغییر وضعیت اسناد"
              v-on:click="changeStatus($event)"
            >
              <i class="fas fa-exchange-alt fa-2x m-1 text-white"></i>
            </a>
            <keep-alive>
              <ChangeStatusDoc
                v-if="isShowChangeStatusDoc"
                v-bind:LocationShow="LocationShowChangeStatusDoc"
                v-on:HideFilter="HideChangeStatusDoc"
              ></ChangeStatusDoc>
            </keep-alive>
          </div>
          <!-- مرتب سازی شماره اسناد -->
          <a
            class="btn btn-secondary btn-sm btn-floating p-0 m-0 ml-1 d-flex justify-content-around align-items-center"
            style="width: 35px; height: 30px"
            title="مرتب سازی شماره اسناد"
            v-on:click="CallDocOrderToServer()"
          >
            <i class="fas fa-sort-amount-down-alt fa-2x text-white"></i>
          </a>
          <!-- پالایش لیست اسناد -->
          <div style="position: relative">
            <a
              class="btn btn-sm btn-floating p-0 m-0 ml-1 d-flex justify-content-around align-items-center"
              :class="
                isShowFilterListDocAcc == true || ActiveFilterCheck == true
                  ? 'btn-warning'
                  : 'btn-secondary'
              "
              style="width: 35px; height: 30px"
              v-bind:style="
                isShowFilterListDocAcc
                  ? 'background-color: #33b5e5;'
                  : 'background-color: #a6c;'
              "
              title="پالایش لیست اسناد"
              v-on:click="filterListAcc($event)"
            >
              <i class="fas fa-filter fa-1x-half text-white"></i>
            </a>
            <keep-alive>
              <FilterListDocInfo
                v-if="isShowFilterListDocAcc"
                v-bind:LocationShow="LocationShowFilterSDocDesc"
                v-on:HideFilter="HideFilterDoc"
              ></FilterListDocInfo>
            </keep-alive>
          </div>
          <!-- ایجاد سند جدید -->
          <a
            class="btn btn-secondary btn-sm btn-floating p-0 m-0 d-flex justify-content-around align-items-center"
            style="width: 80px; height: 30px"
            title="ایجاد سند جدید"
            v-on:click="addNewTab('AccDoc')"
          >
            سند جدید
            <i class="fas fa-file-invoice fa-2x text-white"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-sm text-center table-font-size">
        <thead style="background-color: #f7f7f7; height: 32px" id="FirstRow">
          <td :colspan="intPageNumber > 1 ? 2 : 1">
            <!-- انتقال به سطر انتهایی -->
            <a
              v-on:click="scrollTable('LastRow')"
              title="مشاهده سطر انتهایی"
              class="d-flex justify-content-center align-items-center"
            >
              <i
                class="far fa-arrow-alt-circle-down fa-1x-half text-secondary"
              ></i>
            </a>
          </td>
          <td colspan="11">
            <span>
              تعداد کل اسناد
              {{
                (ActiveFilterCheck == true ? " فیلتر شده : " : " : ") +
                ListTbDocInfoLocal.length
              }}
              مورد
            </span>
            <template v-if="intCountPage > 1">
              <span class="mr-4">صفحه : {{ intPageNumber }}</span>
              <span class="mr-2">از : {{ intCountPage }}</span>
            </template>
          </td>
        </thead>
        <!-- سربرگ جدول -->
        <thead class="text-light bg-secondary" style="height: 32px">
          <td :colspan="intPageNumber > 1 ? 2 : 1">ردیف</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی شناسه سند" v-on:click="sortDocRow('NId', '')">
              شناسه سند
            </a>
          </td> -->
          <td>شناسه سند</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی سال" v-on:click="sortDocRow('NYear', '')">
              سال
            </a>
          </td> -->
          <td>سال</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی شماره سند" v-on:click="sortDocRow('NDocNu', '')">
              شماره سند
            </a>
          </td> -->
          <td>شماره سند</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی تاریخ" v-on:click="sortDocRow('SDocDate', '')">
              تاریخ
            </a>
          </td> -->
          <td>تاریخ</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی نوع" v-on:click="sortDocRow('SDocType', '')">
              نوع
            </a>
          </td> -->
          <td>نوع</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی شرح" v-on:click="sortDocRow('SDocDesc', '')">
              شرح
            </a>
          </td> -->
          <td>شرح</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی بدهکار" v-on:click="sortDocRow('NDebit', '')">
              بدهکار
            </a>
          </td> -->
          <td>بدهکار</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی بستانکار" v-on:click="sortDocRow('NCredit', '')">بستانکار</a>
          </td> -->
          <td>بستانکار</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی وضعیت" v-on:click="sortDocRow('SStatus', '')">
              وضعیت
            </a>
          </td> -->
          <td>وضعیت</td>
          <!-- <td>
            <a class="custom-cursor" title="مرتب سازی سازمان" v-on:click="sortDocRow('SOrgCode', '')">
              سازمان
            </a>
          </td> -->
          <td>سازمان</td>
          <td>مدیریت</td>
        </thead>
        <!-- بدنه جدول -->
        <tbody>
          <!-- آیا دریافت اطلاعات از سرور کامل شده است ؟ -->
          <template v-if="EndGetDataFromServer == true">
            <!-- آیا اطلاعاتی در سرور مشاهده شد ؟ -->
            <template v-if="ListTbDocInfoLocal.length > 0">
              <template v-for="(row, index) in getListDataPaging">
                <tr
                  :key="row.NId"
                  :class="{ selRow: SelectRowID == row.NId }"
                  v-on:click="SaveRowSelect(row.NId, row.NDocNu)"
                  v-on:dblclick="dblClickRow(row.NId, row.NDocNu, row.BStatus)"
                  v-bind:id="row.NId"
                  style="cursor: pointer"
                >
                  <!-- ردیف -->
                  <td
                    v-if="intPageNumber > 1"
                    style="
                      max-width: 35px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ index + 1 }}
                  </td>
                  <td
                    style="
                      max-width: 50px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.RowID }}
                  </td>
                  <!-- شناسه سند -->
                  <td
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.NId }}
                  </td>
                  <!-- سال -->
                  <td
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.NYear }}
                  </td>
                  <!-- شماره سند -->
                  <td
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.NDocNu }}
                  </td>
                  <!-- تاریخ -->
                  <td
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.SDocDate }}
                  </td>
                  <!-- نوع -->
                  <td
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.SDocType }}
                  </td>
                  <!-- شرح -->
                  <td
                    style="
                      text-align: right !important;
                      padding-right: 5px !important;
                      max-width: 250px;
                    "
                  >
                    <!-- استفاده از پاپ آپ سفارشی -->
                    <DescriptionByTooltip
                      v-bind:DescritionData="row.SDocDesc"
                      v-bind:showTop="
                        index + 5 < intCountRowShow ? false : true
                      "
                    ></DescriptionByTooltip>
                    <!-- استفاده از پاپ آپ پیش فرض -->
                    <!-- <div :title="row.SDocDesc" style="
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      width: 100%;
                    ">
                      {{ row.SDocDesc }}
                    </div> -->
                  </td>
                  <!-- بدهکار -->
                  <td
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.NDebit | numFormat }}
                  </td>
                  <!-- بستانکار -->
                  <td
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.NCredit | numFormat }}
                  </td>
                  <!-- وضعیت -->
                  <td
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.SStatus }}
                  </td>
                  <!-- سازمان -->
                  <td
                    :title="row.SOrgCode"
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    "
                  >
                    {{ row.SOrgCode }}
                  </td>
                  <!-- مدیریت -->
                  <td
                    style="
                      max-width: 120px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      padding-left: 5px !important;
                      padding-right: 5px !important;
                    "
                  >
                    <!-- منوی تغییر وضعیت سند -->
                    <!-- <a
                          href="#"
                          title="تغییر وضعیت سند"
                          v-on:click="changeDocStatus(row.NId, row.NDocNu, row.BStatus)"
                      >
                          <i class="fas fa-exchange-alt fa-lg m-1 text-primary"></i>
                      </a> -->
                    <!-- منوی مشاهده سند -->
                    <a
                      href="#"
                      title="مراجعه به سند"
                      v-on:click="
                        showDocInfoData(row.NId, row.NDocNu, row.BStatus)
                      "
                    >
                      <i class="fas fa-file-alt fa-lg m-1 text-primary"></i>
                    </a>
                    <!-- منوی کپی از سند -->
                    <a
                      href="#"
                      title="کپی از سند"
                      v-on:click="CopyDocRowToNewDoc(row.NId, row.NDocNu)"
                    >
                      <i class="fas fa-copy fa-lg m-1 text-primary"></i>
                    </a>
                    <!-- منوی مشاهده لیست حساب های سند در زیر همین سطر -->
                    <a
                      href="#"
                      title="مشاهده لیست حساب‌ها"
                      v-on:click="ShowDocRow(row.NId, row.NDocNu)"
                    >
                      <i
                        v-if="checkShowDocRow != row.NId"
                        class="fas fa-angle-left m-1 text-primary"
                      ></i>
                      <i v-else class="fas fa-angle-down m-1 text-primary"></i>
                    </a>
                  </td>
                </tr>
                <tr
                  v-if="checkShowDocRow == row.NId"
                  :key="'docRows' + row.NId"
                >
                  <td
                    colspan="13"
                    style="padding: 5px 15px !important"
                    :style="
                      checkShowRowDoc == false
                        ? 'background-color: #ffffff;'
                        : 'background-color: #f1fdff;'
                    "
                  >
                    <span
                      v-if="checkShowRowDoc == false"
                      class="d-flex flex-column justify-content-center align-items-center my-2 h10 text-info"
                    >
                      <img
                        style="width: 150px; height: 50px"
                        :src="waitImage"
                        alt="لطفا چند لحظه صبر کنید ..."
                      />
                      در حال دریافت اطلاعات از سرور ...
                    </span>
                    <div v-else class="table-responsive">
                      <div class="row justify-content-between">
                        <div class="mt-2 mb-1 h9 text-info">
                          اطلاعات سطرهای سند شماره {{ row.NDocNu }} ( شناسه :
                          {{ row.NId }} )
                        </div>
                        <!-- جستجوی پیشرفته در لیست سطرهای سند -->
                        <div class="col-4 p-0 pb-2">
                          <div class="input-group p-0">
                            <input
                              id="textDocRowSearch"
                              placeholder="جستجو پیشرفته در لیست سطرهای سند (Enter)"
                              type="text"
                              class="form-control form-control-sm rounded-0"
                              v-on:focus="$event.target.select()"
                              v-on:keyup.enter="
                                searchData($event.target.value);
                                $event.target.select();
                              "
                            />
                            <div class="input-group-prepend rounded-0">
                              <span
                                class="input-group-text input-group-box-size bg-info rounded-left white-text"
                              >
                                <a v-on:click="searchData('Search')">
                                  <i class="fas fa-search"></i>
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <table
                        class="table table-bordered table-sm text-center table-font-size bg-white"
                      >
                        <!-- سربرگ جدول -->
                        <thead class="text-light bg-info">
                          <!-- ردیف -->
                          <td>ردیف</td>
                          <td>کد حساب</td>
                          <td>طرف حساب</td>
                          <td style="min-width: 70px !important">مرکز هزینه</td>
                          <td style="min-width: 70px !important">قراردادها</td>
                          <td>بدهکار</td>
                          <td>بستانکار</td>
                        </thead>
                        <!-- محتویات جدول -->
                        <tbody>
                          <template
                            v-for="item in docDataForShowRow.ListTbAccDocRecord"
                          >
                            <tr
                              :key="item.NIOId"
                              :id="'DocRow_' + item.NIOId"
                              class="rowBoxShadow"
                              :class="
                                SelectDocRowNIOId == item.NIOId ? 'selRow' : ''
                              "
                            >
                              <!-- ردیف -->
                              <td class="tdGradient2" rowspan="2">
                                {{ item.NIOId }}
                              </td>
                              <!-- کد حساب -->
                              <td class="tdGradient">
                                {{ item.NAccCode }}
                                <span
                                  v-bind:title="item.SAccCode"
                                  class="h12 mr-1"
                                  >{{ item.SAccCode }}</span
                                >
                                <!-- <span class="h8 mr-1">{{
                                  getHesabName(item.NAccCode)
                                }}</span> -->
                              </td>
                              <!-- طرف حساب -->
                              <td class="tdGradient">
                                {{ item.NPerID }}
                                <span
                                  v-bind:title="item.LName"
                                  class="h12 mr-1"
                                  >{{ item.LName }}</span
                                >
                                <!-- <pre>{{ getTarafHesabName(item.NPerID) }}</pre> -->
                                <!-- <span class="h8 mr-1">{{
                                  getTarafHesabName(item.NPerID)
                                }}</span> -->
                              </td>
                              <!-- مرکز هزینه -->
                              <td class="tdGradient">
                                {{ item.NUsePlace }}
                                <span
                                  v-bind:title="item.SUsePlace"
                                  class="h12 mr-1"
                                  >{{ item.SUsePlace }}</span
                                >
                                <!-- <span class="h8 mr-1">{{
                                  getBaseUsePlaceName(item.NUsePlace)
                                }}</span> -->
                              </td>
                              <!-- قراردادها -->
                              <td class="tdGradient">
                                {{ item.NAgrID }}
                                <span
                                  v-bind:title="item.SAgreement"
                                  class="h12 mr-1"
                                  >{{ item.SAgreement }}</span
                                >
                                <!-- <span class="h8 mr-1">{{
                                  getBaseAgreementName(item.NAgrID)
                                }}</span> -->
                              </td>
                              <!-- بدهکار -->
                              <td
                                class="tdGradient2"
                                rowspan="2"
                                style="font-weight: 500 !important"
                              >
                                {{ item.NDebit | numFormat }}
                              </td>
                              <!-- بستانکار -->
                              <td
                                class="tdGradient2"
                                rowspan="2"
                                style="font-weight: 500 !important"
                              >
                                {{ item.NCredit | numFormat }}
                              </td>
                            </tr>
                            <!-- شرح حساب -->
                            <tr :key="'SAccDesc' + item.NIOId">
                              <td
                                colspan="4"
                                class="text-truncate"
                                style="
                                  text-align: right !important;
                                  padding-right: 5px !important;
                                  padding-top: 2px !important;
                                  padding-bottom: 2px !important;
                                "
                              >
                                شرح : {{ item.SAccDesc }}
                              </td>
                              <!-- <td colspan="4" class="text-truncate" style="
                                      text-align: right !important;
                                      padding-right: 5px !important;
                                  ">
                                شرح : {{ item.SAccDesc }}
                              </td> -->
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
            <!-- عدم مشاهده اطلاعات در سرور -->
            <template v-else>
              <tr style="height: 50px">
                <td colspan="13">
                  <span> در سرور اطلاعاتی مشاهده نشد ! </span>
                </td>
              </tr>
            </template>
          </template>
          <!-- در حال دریافت اطلاعات از سرور -->
          <template v-else>
            <tr style="height: 50px">
              <td colspan="13">
                <span> در حال دریافت اطلاعات از سرور ... </span>
              </td>
            </tr>
          </template>
        </tbody>
        <tfoot style="background-color: #f7f7f7; height: 32px" id="LastRow">
          <td :colspan="intPageNumber > 1 ? 2 : 1">
            <!-- انتقال به سطر ابتدایی -->
            <a
              v-on:click="scrollTable('FirstRow')"
              title="مشاهده سطر ابتدایی"
              class="d-flex justify-content-center align-items-center"
            >
              <i
                class="far fa-arrow-alt-circle-up fa-1x-half text-secondary"
              ></i>
            </a>
          </td>
          <td colspan="11">
            <Pagination
              v-bind:Name="'ListTbDocInfo'"
              v-bind:CountRow="intCountRow"
              v-bind:DataRepository="ListTbDocInfoLocal"
              v-on:ChangePage="ChangePage"
            ></Pagination>
          </td>
        </tfoot>
      </table>
    </div>
  </div>
  <!-- پایان محتویات تب لیست اسناد -->
</template>

<script>
import FilterListDocInfo from "./FilterListDocInfo.vue";
import ChangeStatusDoc from "./ChangeStatusDoc.vue";
import DescriptionByTooltip from "../../PublicComponents/DescriptionByTooltip.vue";
import Pagination from "../../PublicComponents/Pagination.vue";
import { BusEvent } from "../../../../../main.js";

export default {
  name: "Tab1_ListSanad",
  components: {
    FilterListDocInfo,
    ChangeStatusDoc,
    DescriptionByTooltip,
    Pagination,
  },
  data() {
    return {
      // بررسی زمان دریافت اطلاعات از سرور
      EndGetDataFromServer: false,
      // آیدی سطر انتخاب شده
      SelectRowID: 1,
      // اطلاعات سطر انتخاب شده
      SelectRowData: {
        NId: 0,
        NDocNu: 0,
      },
      // مربوط به صفحه بندی
      intPageNumber: 1, // شماره صفحه در حال انتخاب
      intCountRow: 200, // تعداد سطرها در هر صفحه
      intCountPage: 1, // تعداد کل صفحه ها
      intCountRowShow: 1, // تعداد سطرهای مشاهده شده در صفحه - ممکن است صفحه 200 سطر کامل نباشد
      // لیست اسناد محلی
      ListTbDocInfoLocal: [],
      // لیست اسناد فیلتر شده
      ListTbDocInfoFilter: [],
      // کنترل وضعیت فعال بودن فیلتر
      ActiveFilterCheck: true,
      // موارد جستجو شده قبلی
      ListSearchOld: "",
      // موارد جستجو شده قبلی در سطرهای سند
      NIOIdSearch: [],
      // سطر در حال انتخاب از سطرهای سند
      SelectDocRowNIOId: 0,
      // فیلد نگهداری نام آخرین فیلد مرتب سازی شده
      lastSortFieldName: "",
      // کنترل وضعیت نمایش سطرهای سند
      checkShowDocRow: 0,
      // آدرس تصویر لطفا صبر کنید
      waitImage: this.$store.getters.getImageUrl + "wait.gif",
      // اطلاعات سندی که تقاضای مشاهده ردیف های آن شده است
      docDataForShowRow: {
        NId: 0,
        NYear: 0,
        NDocNu: 0,
        SDocDate: "",
        SDocDesc: "",
        NDocType: 0,
        NUserCode: 0,
        ListTbAccDocRecord: [],
        CheckChangeData: false,
      },
      // مدیریت نمایش جدول سطرهای سند
      checkShowRowDoc: false,
      // مدیریت نمایش پالایش لیست اسناد
      isShowFilterListDocAcc: false,
      LocationShowFilterSDocDesc: {
        left: 1,
        top: 1,
        width: 100,
        height: 100,
      },
      // مدیریت نمایش تغییر وضعیت اسناد
      isShowChangeStatusDoc: false,
      LocationShowChangeStatusDoc: {
        left: 1,
        top: 1,
        width: 100,
        height: 100,
      },
    };
  },
  created() {
    this.getListTbDocInfoFromServer();
    // تعریف رویداد تغییر تب فعال
    BusEvent.$on(
      "CallRestDocList_Tab1_ListSanad",
      this.CallRestDocList_Tab1_ListSanad
    );
  },
  updated() {
    // this.checkUpdated();
  },
  computed: {
    // نمایش اطلاعات با قابلیت صفحه بندی
    getListDataPaging() {
      // نگهداری لیست دریافتی از سرور در مخزن محلی
      // از روی اطلاعات موجود در این مخزن ، صفحه بندی و جستجو اعمال می شود
      // this.ListTbDocInfoLocal = this.$store.getters.getListTbDocInfo;
      if (this.ListTbDocInfoLocal.length > 0) {
        // شماره شروع رکورد
        let startRowIndex =
          this.intPageNumber == 1
            ? 1
            : parseInt(this.intCountRow) * (parseInt(this.intPageNumber) - 1) +
              1;
        let intCountRowLocal = this.intCountRow;
        // انتخاب رکوردهای صفحه مورد نظر
        let ListTemplate = [];
        ListTemplate = this.ListTbDocInfoLocal.filter(function (item) {
          return (
            item.RowID >= startRowIndex &&
            item.RowID < parseInt(startRowIndex) + parseInt(intCountRowLocal)
          );
        });
        // نگهداری تعداد سطر در حال نمایش
        // جهت مدیریت نمایش پاپ آپ توضیحات کاربرد دارد
        this.intCountRowShow = ListTemplate.length;
        // خروجی لیست صفحه مورد نظر
        return ListTemplate;
      } else {
        return [];
      }
    },
  },
  methods: {
    async CallRestDocList_Tab1_ListSanad(NId, checkDelete = true, NewData) {
      // این تابع در لحظه حذف سند تحریک می شود
      // و باعث بروزرسانی لیست اسناد می گردد
      if (this.ActiveFilterCheck == true) {
        // چون وضعیت فیلتر فعال است
        // لذا لیست محلی از نتیجه فیلتر پر می شود
        if (checkDelete == true){
          // سندی از لیست حذف شده است
          this.ListTbDocInfoFilter = this.ListTbDocInfoFilter.filter(function (t) {
            return t.NId != NId;
          });
        } else {
          // سطر جدید اضافه شده موقتا به لیست فیلتر اضافه می شود
          // هدف نمایش نتیجه کار به کاربر است
          let tempData = {};
          tempData.RowID = this.ListTbDocInfoFilter.length + 1;
          // شناسه سند
          tempData.NId = NewData.NId;
          // سال سند
          tempData.NYear = NewData.NYear;
          // شماره سند
          tempData.NDocNu = NewData.NDocNu;
          // تاریخ سند
          tempData.SDocDate = NewData.SDocDate;
          // نوع سند
          tempData.SDocType = 'عمومی';
          // شرح سند
          tempData.SDocDesc = NewData.SDocDesc;
          // محاسبه بدهکار
          let NDebit = 0;
          NewData.ListTbAccDocRecord.forEach(element => {
            NDebit += parseInt(element.NDebit);
          });
          tempData.NDebit = NDebit;
          // محاسبه بستانکار
          let NCredit = 0;
          NewData.ListTbAccDocRecord.forEach(element => {
            NCredit += parseInt(element.NCredit);
          });
          tempData.NCredit = NCredit;
          // وضعیت
          tempData.SStatus = 'موقت';
          // سازمان
          tempData.SOrgCode = this.$store.getters.getOrgNameFromOrgCode(NewData.NOrgCode);

          // افزودن سند جدید به صورت موقت به لیست فیلترها
          this.ListTbDocInfoFilter.unshift(tempData);
        }
        this.ListTbDocInfoLocal = this.ListTbDocInfoFilter;
      } else {
        // بازیابی اطلاعات از مخزن اصلی در مخزن محلی
        this.ListTbDocInfoLocal = await this.$store.getters.getListTbDocInfo;
      }
    },
    checkUpdated() {
      console.log("Update ...", this.SelectRowID);
      $("#" + this.SelectRowID).scrollintoview({
        duration: 500,
        //complete: this.$store.dispatch("notify", { notText: "تست نمایش پیام !!", timeOut: 2500, });
      });
    },
    // مشاهده تغییر در شماره صفحه
    // توسط کامپاننت صفحه بندی فراخوانی می شود
    ChangePage(value) {
      if (this.intPageNumber != value.pageNumber) {
        // اگر صفحه تغییر کرده بود به آخرین سطر برو
        this.scrollTable("LastRow");
      }
      this.intPageNumber = value.pageNumber;
      this.intCountRow = value.countRow;
      this.intCountPage = value.countPage;
    },
    // دریافت لیست اسناد از سرور
    async getListTbDocInfoFromServer() {
      let userData = await this.$store.getters.getUserData;
      // let NUserCode = userData.NUserCode;
      let token = userData.token;
      let yearActive = await this.$store.getters.getYearActive;

      // دریافت لیست اسناد از سرور
      await this.$store.dispatch("getListTbDocInfoFromServer", {
        yearID: yearActive,
        // NUserCode: NUserCode,
        token: token,
      });
      // نگهداری لیست دریافتی از سرور در مخزن محلی
      // از روی اطلاعات موجود در این مخزن ، صفحه بندی و جستجو اعمال می شود
      this.ListTbDocInfoLocal = await this.$store.getters.getListTbDocInfo;
      // اعلام لغو فیلتر اطلاعات
      this.ActiveFilterCheck = false;
      // تخلیه لیست فیلتر اطلاعات محلی
      this.ListTbDocInfoFilter = [];
      // اعلام پایان بازیابی اطلاعات از سرور
      this.EndGetDataFromServer = true;
    },
    // جابجایی به سطر انتهایی یا ابتدایی
    scrollTable(objectID) {
      $("#" + objectID).scrollintoview({
        duration: 500,
      });
    },
    // تغییر وضعیت سند به دائمی
    changeDocStatus(NId, NDocNu, BStatus) {
      if (BStatus == false) {
        swal({
          title: "تغییر وضعیت سند",
          text: "شما تقاضای تغییر وضعیت سند به قطعی را داده اید .\nپس از تغییر وضعیت سند ، دیگر قادر به ویرایش اطلاعات سند نمی‌باشید . آیا ادامه می دهید ؟",
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "انصراف",
            ok: "بله انجام میدهم",
          },
          // content: "input",
          // closeModal: false,
          // dangerMode: true,
        }).then(async (value) => {
          if (value) {
            var checkStatus = await this.$store.dispatch(
              "changeDocStatusInServer",
              {
                NId,
              }
            );
            if (checkStatus) {
              this.$store.dispatch("notify", {
                notText: "وضعیت سند به قطعی تغییر کرد .",
                timeOut: 2500,
              });
            }
          }
        });
      } else {
        this.$store.dispatch("notify", {
          notText: "وضعیت سند قطعی است !\nنیاز به تغییر ندارد .",
          timeOut: 2500,
        });
      }
    },
    // بسته شدن فیلتر لیست اسناد
    async HideFilterDoc(listResult) {
      if (listResult != "") {
        // لیست حاصل از فیلتر که از کامپاننت فیلتر
        // بازگشته است در مخزن محلی قرار می گیرد
        this.ListTbDocInfoFilter = listResult;
        this.ListTbDocInfoLocal = this.ListTbDocInfoFilter;
        // اعلام فعال شدن فیلتر
        this.ActiveFilterCheck = true;
      } else {
        // نگهداری لیست دریافتی از سرور در مخزن محلی
        // از روی اطلاعات موجود در این مخزن ، صفحه بندی و جستجو اعمال می شود
        this.ListTbDocInfoLocal = await this.$store.getters.getListTbDocInfo;
        // اعلام غیرفعال شدن فیلتر
        this.ActiveFilterCheck = false;
        // خالی کردن لیست محلی نتیجه فیلتر
        this.ListTbDocInfoFilter = [];
      }
      this.isShowFilterListDocAcc = false;
    },
    // بسته شدن تغییر وضعیت اسناد
    HideChangeStatusDoc(listResult) {
      // دریافت لیست اسناد از مخزن اصلی
      this.ListTbDocInfoLocal = this.$store.getters.getListTbDocInfo;
      // مخفی کردن کادر تغییر وضعیت اسناد
      this.isShowChangeStatusDoc = false;
    },
    // فراخوانی کامپاننت فیلتر لیست اسناد
    async filterListAcc(event) {
      // دریافت موقعیت والد و ارسال به کامپاننت فرزند
      this.LocationShowFilterSDocDesc.left = event.target.clientLeft;
      this.LocationShowFilterSDocDesc.top = event.target.clientTop;
      this.LocationShowFilterSDocDesc.width = event.target.clientWidth;
      this.LocationShowFilterSDocDesc.height = event.target.clientHeight;
      // نمایش کامپاننت فیلتر لیست اسناد
      this.isShowFilterListDocAcc = !this.isShowFilterListDocAcc;
      this.isShowChangeStatusDoc = false;
    },
    // فراخوانی کامپاننت تغییر وضعیت اسناد
    async changeStatus(event) {
      // دریافت موقعیت والد و ارسال به کامپاننت فرزند
      this.LocationShowChangeStatusDoc.left = event.target.clientLeft;
      this.LocationShowChangeStatusDoc.top = event.target.clientTop;
      this.LocationShowChangeStatusDoc.width = event.target.clientWidth;
      this.LocationShowChangeStatusDoc.height = event.target.clientHeight;
      // نمایش کامپاننت فیلتر لیست اسناد
      this.isShowChangeStatusDoc = !this.isShowChangeStatusDoc;
      this.isShowFilterListDocAcc = false;
    },
    // مرتب سازی لیست اسناد توسط پروسیجر سمت سرور
    async CallDocOrderToServer() {
      swal({
        title: "مرتب سازی اسناد",
        text: "شما تقاضای مرتب سازی اسناد را داده اید . آیا ادامه می دهید ؟",
        icon: "warning", // success, warning, error, info
        buttons: {
          cancel: "انصراف",
          ok: "بله انجام میدهم",
        },
        // content: "input",
        // closeModal: false,
        // dangerMode: true,
      }).then(async (value) => {
        if (value) {
          let userData = await this.$store.getters.getUserData;
          let token = userData.token;
          // let nuserCode = userData.NUserCode;
          let yearActive = await this.$store.getters.getYearActive;

          // مرتب سازی لیست اسناد سمت سرور
          await this.$store.dispatch("CallDocOrderToServer", {
            yearActive: yearActive,
            token: token,
          });
        }
      });
    },
    // انتخاب سطر جهت نمایش ردیف های سند
    async ShowDocRow(NId, NDocNu) {
      if (this.checkShowDocRow != NId) {
        // نمایش سطرهای سند جاری
        this.checkShowDocRow = NId;
        // بازیابی اطلاعات سند جاری از سرور
        this.docDataForShowRow = await this.SearchNIdNDocNuInServer(
          NId,
          NDocNu
        );
        // نمایش جدول سطرهای سند
        this.checkShowRowDoc = true;
      } else {
        // تنظیم عدم نمایش سطرهای سند
        this.checkShowDocRow = 0;
        // عدم نمایش جدول سطرهای سند
        this.checkShowRowDoc = false;
      }
    },
    // کپی از سند جاری
    async CopyDocRowToNewDoc(nId, nDocNu) {
      var docData = await this.SearchNIdNDocNuInServer(nId, nDocNu);
      // ایجاد تب جدید با محتویات سند جاری
      this.addNewTab("AccDoc", true, docData);
    },
    // ایجاد تب جدید + کپی از سند جاری
    async addNewTab(tabType, localdata = false, tabdata = {}) {
      // دریافت کد برای تب جدید
      var newNDocNum = await this.$store.dispatch("createNewNDouNum");
      if (newNDocNum == 1) {
        newNDocNum = await this.$store.getters.getLargestNDocNuNId;
      }
      if (localdata == true) {
        var shamsi = require("shamsi-date-converter");
        var currentDate = shamsi.gregorianToJalali(new Date());
        tabdata.NDocNu = newNDocNum;
        tabdata.NId = 0;
        tabdata.SDocDate =
          currentDate[0] +
          "/" +
          currentDate[1].toString().padStart(2, "0") +
          "/" +
          currentDate[2].toString().padStart(2, "0");
        tabdata.NYear = currentDate[0];
      }
      // ایجاد اطلاعات تب جدید
      var tabData = {
        tabID: 0,
        tabContent: tabType,
        NId: 0,
        NDocNu: newNDocNum,
        CheckChangeData: false,
        LocalData: localdata,
        TabAccDocData: tabdata,
      };
      // ایجاد تب جدید
      this.$store.commit("addTabList", tabData);
      // ارسال شماره تب به رویداد تغییر تب فعال
      BusEvent.$emit("ChangeTabActive", tabData.tabID);
    },
    // دریافت اطلاعات سند از سرور
    async SearchNIdNDocNuInServer(nId, nDocNu) {
      let userData = await this.$store.getters.getUserData;
      let NUserCode = userData.NUserCode;
      let token = userData.token;
      let yearActive = await this.$store.getters.getYearActive;

      // دریافت اطلاعات سند با استفاده از کد سند از سرور
      var docData = await this.$store.dispatch(
        "GetTbDocInfoByNIdNDocNuFromServer",
        {
          NId: nId,
          NDocNu: nDocNu,
          NYear: yearActive,
          NUserCode: NUserCode,
          token: token,
        }
      );
      return docData;
    },
    // دابل کلیک بر روی سطر
    dblClickRow(NId, NDocNu, BStatus) {
      this.SaveRowSelect(NId, NDocNu);
      this.showDocInfoData(NId, NDocNu, BStatus);
    },
    // نگهداری اطلاعات سطر انتخاب شده
    SaveRowSelect(NId, NDocNu) {
      this.SelectRowData = { NId: NId, NDocNu: NDocNu };
      this.SelectRowID = NId;
    },
    // جستجو در لیست سطرهای سند
    // با انتقال فوکوس به سطر پیدا شده
    searchData(searchValue) {
      if (searchValue === "Search") {
        searchValue =
          $("#textDocRowSearch").val() != ""
            ? $("#textDocRowSearch").val()
            : "";
      }
      if (searchValue != "") {
        console.log("len : ", this.docDataForShowRow.ListTbAccDocRecord.length);
        let index = this.docDataForShowRow.ListTbAccDocRecord.findIndex(
          (itme) =>
            (itme.NIOId.toString().startsWith(searchValue) ||
              itme.NAccCode.toString().startsWith(searchValue) ||
              itme.SAccCode.toString().includes(searchValue) ||
              itme.NPerID.toString().startsWith(searchValue) ||
              itme.LName.toString().includes(searchValue) ||
              itme.NUsePlace.toString().startsWith(searchValue) ||
              itme.SUsePlace.toString().includes(searchValue) ||
              itme.NAgrID.toString().startsWith(searchValue) ||
              itme.SAgreement.toString().includes(searchValue) ||
              itme.NDebit.toString().startsWith(searchValue) ||
              itme.NCredit.toString().startsWith(searchValue) ||
              itme.SAccDesc.toString().includes(searchValue)) &&
            this.NIOIdSearch.indexOf(itme.NIOId) == -1
        );
        if (index != -1) {
          let NIOId = this.docDataForShowRow.ListTbAccDocRecord[index].NIOId;
          $("#DocRow_" + NIOId).scrollintoview({
            duration: 500,
            //complete: this.$store.dispatch("notify", { notText: "تست نمایش پیام !!", timeOut: 2500, });
          });
          this.SelectDocRowNIOId = NIOId;
          this.NIOIdSearch.push(NIOId);
        } else {
          this.SelectDocRowNIOId = 0;
          this.NIOIdSearch = [];
          $("#textDocRowSearch").scrollintoview({
            duration: 500,
            //complete: this.$store.dispatch("notify", { notText: "تست نمایش پیام !!", timeOut: 2500, });
          });
        }
      } else {
        this.$store.dispatch("notify", {
          notText: "مقداری برای جستجو درج نشده است !",
          timeOut: 2500,
        });
        this.NIOIdSearch = [];
      }
    },
    // جستجو در لیست اسناد
    // به روش فیلتر لیست
    async FilterDataInSearch(searchValue) {
      if (searchValue === "Search") {
        searchValue =
          $("#textDocInfoSearch").val() != ""
            ? $("#textDocInfoSearch").val()
            : "";
      }
      if (searchValue != "") {
        let ListTemp = this.ListTbDocInfoLocal;
        // if (this.ActiveFilterCheck == true){
        //   // چون وضعیت فیلتر فعال است
        //   // لذا جستجو روی لیست فیلتر انجام می شود
        //   ListTemp = this.ListTbDocInfoFilter;
        // } else {
        //   ListTemp = await this.$store.getters.getListTbDocInfo;
        // }
        ListTemp = ListTemp.filter(
          (item) =>
            item.NId.toString().startsWith(searchValue) ||
            item.NYear.toString().startsWith(searchValue) ||
            item.NDocNu.toString().startsWith(searchValue) ||
            item.SDocDate.toString().startsWith(searchValue) ||
            item.SDocType.toString().includes(searchValue) ||
            item.SDocDesc.toString().includes(searchValue) ||
            item.NDebit.toString().startsWith(searchValue) ||
            item.NCredit.toString().startsWith(searchValue) ||
            item.SStatus.toString().includes(searchValue) ||
            item.SOrgCode.toString().includes(searchValue)
        );
        ListTemp = await this.$store.dispatch("setRowIDForList", ListTemp);
        this.ListTbDocInfoLocal = ListTemp;
        // نگهداری موارد جستجوی قبلی
        this.ListSearchOld +=
          (this.ListSearchOld != "" ? "/ " : "") + searchValue;
      } else {
        if (this.ActiveFilterCheck == true) {
          // چون وضعیت فیلتر فعال است
          // لذا لیست محلی از نتیجه فیلتر پر می شود
          this.ListTbDocInfoLocal = this.ListTbDocInfoFilter;
        } else {
          // بازیابی اطلاعات از مخزن اصلی در مخزن محلی
          this.ListTbDocInfoLocal = await this.$store.getters.getListTbDocInfo;
        }
        // تخلیه موارد جستجوی قبلی
        this.ListSearchOld = "";
      }
    },

    // حذف اطلاعات سند از سرور
    // async deleteDataFromServer(NId, NDocNu) {
    //   swal({
    //     title: "حذف سند",
    //     text:
    //       "شما تقاضا حذف سند شماره " +
    //       NDocNu +
    //       " را کرده اید . آیا ادامه می دهید؟",
    //     icon: "warning", // success, warning, error, info
    //     buttons: {
    //       cancel: "انصراف",
    //       ok: "بله انجام میدهم",
    //     },
    //     // content: "input",
    //     // closeModal: false,
    //     // dangerMode: true,
    //   }).then(async (value) => {
    //     if (value) {
    //       let token = await this.$store.getters.getUserData.token;
    //       var check = await this.$store.dispatch("deleteDocInfoFromServer", {
    //         tmpDocID: { NId: NId, NDocNu: NDocNu },
    //         token: token,
    //       });
    //       if (check) {
    //         // عمل حذف از سرور انجام شد
    //         // حذف سطر مورد نظر از مخزن محلی

    //         // this.getListTbDocInfoLocal();
    //       }
    //     }
    //   });
    // },

    // مشاهده اطلاعات سند
    showDocInfoData(NId, NDocNu, BStatus) {
      // آیا سند از نوع دائم است ؟
      if (BStatus == true) {
        // سند از نوع دائم است و کاربر مجاز به ویرایش آن نمی باشد
        this.$store.dispatch("notify", {
          notText:
            "عدم ویرایش سند !\n شما مجاز به ویرایش سند از نوع دائم نمی باشید .",
          timeOut: 2500,
        });
      }
      // بارگیری اطلاعات سند جهت نمایش به کاربر
      var tabData = {
        tabContent: "AccDoc",
        NId: NId,
        NDocNu: NDocNu,
        tabID: 0,
        CheckChangeData: false,
        LocalData: false,
        readOnly: true,
      };
      this.$store.commit(
        "addTabList",
        tabData,
        this.$store.getters.getUserData.NUserCode
      );
      // ارسال شماره تب به رویداد تغییر تب فعال
      BusEvent.$emit("ChangeTabActive", tabData.tabID);
    },
    // مرتب سازی لیست بر اساس فیلد انتخابی
    sortDocRow: function (sortFieldName, sortFieldType) {
      // منبع مطلب
      // https://www.codegrepper.com/code-examples/javascript/frameworks/vue/Sort+numbers+in+javascript
      let docrow = this.ListTbDocInfoLocal;
      // بررسی وضعیت مرتب سازی صعودی یا نزولی
      if (sortFieldType === "") {
        if (this.lastSortFieldName === sortFieldName) {
          // فیلد تکراری است لذا مرتب سازی از بزرگ به کوچک
          sortFieldType = "desc";
          // تخلیه نام آخرین فیلد مرتب سازی شده
          this.lastSortFieldName = "";
        } else {
          // فیلد جدید است لذا مرتب سازی از کوچک به بزرگ
          sortFieldType = "asc";
          // نگهداری نام آخرین فیلد مرتب سازی شده
          this.lastSortFieldName = sortFieldName;
        }
      }

      // Set slice() to avoid to generate an infinite loop!
      // تکه تکه کردن() برای جلوگیری از تولید یک حلقه بی نهایت!
      if (docrow.length > 0) {
        if (sortFieldName === "NId") {
          // شناسه سند
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfoLocal = docrow.sort((a, b) => a.NId - b.NId);
          else this.ListTbDocInfoLocal = docrow.sort((a, b) => b.NId - a.NId);
        }
        if (sortFieldName === "NYear") {
          // سال
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfoLocal = docrow.sort((a, b) => a.NYear - b.NYear);
          else
            this.ListTbDocInfoLocal = docrow.sort((a, b) => b.NYear - a.NYear);
        } else if (sortFieldName === "NDocNu") {
          // شماره سند
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfoLocal = docrow.sort(
              (a, b) => a.NDocNu - b.NDocNu
            );
          else
            this.ListTbDocInfoLocal = docrow.sort(
              (a, b) => b.NDocNu - a.NDocNu
            );
        } else if (sortFieldName === "SDocDate") {
          // تاریخ
          // مرتب سازی فیلد متنی
          this.ListTbDocInfoLocal = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SDocDate;
              f2 = b.SDocDate;
            } else {
              f1 = b.SDocDate;
              f2 = a.SDocDate;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "SDocType") {
          // نوع سند
          // مرتب سازی فیلد متنی
          this.ListTbDocInfoLocal = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SDocType;
              f2 = b.SDocType;
            } else {
              f1 = b.SDocType;
              f2 = a.SDocType;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "SDocDesc") {
          // شرح سند
          // مرتب سازی فیلد متنی
          this.ListTbDocInfoLocal = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SDocDesc;
              f2 = b.SDocDesc;
            } else {
              f1 = b.SDocDesc;
              f2 = a.SDocDesc;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "NDebit") {
          // بدهکار
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfoLocal = docrow.sort(
              (a, b) => a.NDebit - b.NDebit
            );
          else
            this.ListTbDocInfoLocal = docrow.sort(
              (a, b) => b.NDebit - a.NDebit
            );
        } else if (sortFieldName === "NCredit") {
          // بستانکار
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfoLocal = docrow.sort(
              (a, b) => a.NCredit - b.NCredit
            );
          else
            this.ListTbDocInfoLocal = docrow.sort(
              (a, b) => b.NCredit - a.NCredit
            );
        } else if (sortFieldName === "SStatus") {
          // وضعیت سند
          // مرتب سازی فیلد متنی
          this.ListTbDocInfoLocal = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SStatus;
              f2 = b.SStatus;
            } else {
              f1 = b.SStatus;
              f2 = a.SStatus;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "SOrgCode") {
          // سازمان
          // مرتب سازی فیلد متنی
          this.ListTbDocInfoLocal = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SOrgCode;
              f2 = b.SOrgCode;
            } else {
              f1 = b.SOrgCode;
              f2 = a.SOrgCode;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        }
      } else {
        return [];
      }
    },

    // دریافت نام حساب از روی کد حساب
    // getHesabName(NAccCode) {
    //   var TbBaseAccName = this.$store.getters.getTbBaseAccDataName(NAccCode);
    //   if (TbBaseAccName.SDesc != "") {
    //     return TbBaseAccName.SDesc;
    //   } else {
    //     return "";
    //   }
    // },

    // دریافت نام طرف حساب از روی کد طرف حساب
    // getTarafHesabName(NPerID) {
    //   if (NPerID != 0) {
    //     var tarafData = this.$store.getters.getTbPersonDataNameAndType(NPerID);
    //     var lensubstring = this.$store.getters.getLenSubString;
    //     return (
    //       tarafData.NPerName +
    //       (tarafData.NPerLastName != ""
    //         ? " / " +
    //         (tarafData.NPerLastName.length > lensubstring
    //           ? tarafData.NPerLastName.substring(0, 25) + " ..."
    //           : tarafData.NPerLastName)
    //         : "")
    //     );
    //   } else {
    //     return "";
    //   }
    // },

    // دریافت نام مرکز هزینه از روی کد مرکز هزینه
    // getBaseUsePlaceName(NUsePlace) {
    //   if (NUsePlace != 0) {
    //     var UsePlaceData = this.$store.getters.getTbBaseUsePlaceName(NUsePlace);
    //     var lensubstring = this.$store.getters.getLenSubString;
    //     return UsePlaceData.SDesc != ""
    //       ? UsePlaceData.SDesc.length > lensubstring
    //         ? UsePlaceData.SDesc.substring(0, 25) + " ..."
    //         : UsePlaceData.SDesc
    //       : "";
    //   } else {
    //     return "";
    //   }
    // },

    // دریافت نام قرارداد از روی کد قرارداد
    // getBaseAgreementName(NAgrID) {
    //   if (NAgrID != 0) {
    //     var UsePlaceData = this.$store.getters.getTbBaseAgreementName(NAgrID);
    //     var lensubstring = this.$store.getters.getLenSubString;
    //     return UsePlaceData.SAgrSubject != ""
    //       ? UsePlaceData.SAgrSubject.length > lensubstring
    //         ? UsePlaceData.SAgrSubject.substring(0, 25) + " ..."
    //         : UsePlaceData.SAgrSubject
    //       : "";
    //   } else {
    //     return "";
    //   }
    // },
  },
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}

.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}

.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}

.tdGradient2 {
  background: linear-gradient(
    rgba(233, 233, 233, 0.4),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
}

.custom-cursor {
  /* cursor: url('/src/assets/images/sort-cursor.png'),auto; */
  cursor: ns-resize;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListDocInfo/Components/Tab1_ListSanad.vue